<div class="simulation-shell">
  <div class="main">
    <header class="steps" aria-label="Pasos de la simulación">
      <app-simulation-steps-bar />
    </header>

    <div class="summary-action">
      <app-button
        ariaLabel="Abrir resumen"
        innerId="open-parameters-summary"
        label="Resumen"
        styleClass="secondary small"
        (action)="openParametersSummary()"
      />
    </div>

    <main class="content" aria-label="Paso actual">
      <!-- Step content: swaps as the user moves between steps -->
    </main>

    <!-- TODO: add Continuar button -->
  </div>

  <aside class="summary" aria-label="Resumen de la simulación">
    <app-simulation-summary />
  </aside>
</div>
